module.exports = __webpack_public_path__ + "img/Group (14).18bf9ee8.svg";